import { useLazyQuery } from '@apollo/client';
import { GET_GAME_IQ_QUESTIONS } from '../../apollo/queries/gameIQ';

const useGameIQQuestions = () => {
  const [getQuestions, result] = useLazyQuery(GET_GAME_IQ_QUESTIONS);

  const fetchQuestions = (sport, level) => {
    return getQuestions({ variables: { sport, level } });
  };

  return {
    fetchQuestions,
    questionsData: result.data,
    loading: result.loading,
    error: result.error,
  };
};

export default useGameIQQuestions;